import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import PrescribersSearchDialogListEmpty from './PrescribersSearchDialogListEmpty';
import PrescribersSearchDialogListItem from './PrescribersSearchDialogListItem';

const styles = theme => ({
  root: {
    width: '100%',
    overflow: 'hidden',
  },
  table: {
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    minWidth: 500,
  },
});

const PrescribersSearchDialogList = ({
  prescribers,
  onPrescriberClick,
  submitSucceeded,
  classes,
}) => (
  <div className={classes.root}>
    {prescribers.length === 0 ? (
      <PrescribersSearchDialogListEmpty submitSucceeded={submitSucceeded} />
    ) : (
      <Table className={classes.table}>
        <TableBody>
          {prescribers.map(prescriber => (
            <PrescribersSearchDialogListItem
              key={prescriber.npi}
              {...prescriber}
              {...onPrescriberClick ? { onClick: () => { onPrescriberClick(prescriber); } } : {}}
            />
          ))}
        </TableBody>
      </Table>
    )}
  </div>
);

PrescribersSearchDialogList.propTypes = {
  prescribers: PropTypes.arrayOf(PropTypes.shape({
    npi: PropTypes.number.isRequired,
  })).isRequired,
  onPrescriberClick: PropTypes.func,
  submitSucceeded: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
  }).isRequired,
};

PrescribersSearchDialogList.defaultProps = {
  onPrescriberClick: null,
};

export default withStyles(styles)(PrescribersSearchDialogList);



// WEBPACK FOOTER //
// ./src/components/settings/PrescribersSearchDialog/PrescribersSearchDialogList.js